module.exports = __webpack_public_path__ + "static/media/windows.fcc2f76f.svg";